<div *ngIf="formulier && formulier['formulier']">
    <table class="taglist">
        <tr>
            <td><span class="tag">Formulier</span></td>
            <td>{{formulier['formulier']['FormNaam']}}</td>
        </tr>
        <tr>
            <td><span class="tag">Form.nr.</span></td>
            <td>{{formHdr}}</td>
        </tr>
        <tr>
            <td><span class="tag">Order</span></td>
            <td>{{ordnr}}</td>
        </tr>
    </table>
    <mat-spinner diameter="30" *ngIf="writingJobs"></mat-spinner>
    <mat-tab-group>
        <mat-tab label="Invulvragen">
            <table class="taglist">
                <ng-container *ngFor="let q of formQuestions; let in=index">
                    <tr *ngIf="q.visible && q.fvTyp=='H'">
                        <td colspan="5"><h1>{{q.fvOms}}</h1></td>
                    </tr>
                    <tr *ngIf="q.visible && q.fvTyp=='P'">
                        <td colspan="5">{{q.fvOms}} {{q.fvHelp}}</td>
                    </tr>
                    <tr *ngIf="q.visible && q.fvTyp!='H' && q.fvTyp!='P' && q.fvTyp!='S' && q.fvTyp!='X'">
                        <td>
                            <span class="tag">{{q.fvOms}}</span>
                        </td>
                        <td>
                            <mat-icon *ngIf="q.fvHelp" (click)="q.showHelp=!q.showHelp;" class='iconbtn' size="large">
                                {{q.showHelp ? 'close-circle-outline' : 'information-circle'}}
                            </mat-icon>
                        </td>
                        <td class='answer'>
                            <mat-form-field *ngIf="q.fvTyp=='R'" appearance="fill">
                                <input matInput (input)='evalForm()'
                                    [(ngModel)]="formQuestions[in].value"
                                    [disabled]="formDisable"
                                >
                            </mat-form-field>
                            <mat-form-field *ngIf="q.fvTyp=='TIME'" appearance="fill">
                                <input type="time" step="60" matInput
                                    (input)='evalForm()'
                                    [(ngModel)]="formQuestions[in].value"
                                    [disabled]="formDisable"
                                >
                            </mat-form-field>
                            <mat-form-field *ngIf="q.fvTyp=='DATE'" appearance="fill">
                                <input matInput [matDatepicker]="picker"
                                    (dateChange)="evalForm()"
                                    [(ngModel)]="formQuestions[in].value"
                                    [disabled]="formDisable"
                                >
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field *ngIf="q.fvTyp=='N'" appearance="fill">
                                <input type='number' matInput (input)='evalForm()'
                                    [(ngModel)]="formQuestions[in].value"
                                    [disabled]="formDisable"
                                >
                            </mat-form-field>
                            <mat-form-field *ngIf="q.fvTyp=='T'" appearance="fill">
                                <textarea matInput rows="5" (input)='evalForm()'
                                    [(ngModel)]="formQuestions[in].value"
                                    [disabled]="formDisable"
                                ></textarea>
                            </mat-form-field>
                            <mat-form-field *ngIf="q.fvTyp=='L'" appearance="fill">
                                <mat-select (selectionChange)='evalForm()'
                                    [(ngModel)]="formQuestions[in].value"
                                    [disabled]="formDisable"
                                >
                                    <mat-option *ngFor="let lst of formQuestions[in].choices" [value]="lst.ID">
                                        {{lst.txt}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field *ngIf="q.fvTyp=='M'" appearance="fill">
                                <mat-select (selectionChange)='evalForm()'
                                    [(ngModel)]="formQuestions[in].value"
                                    [disabled]="formDisable"
                                    [multiple]="true"
                                >
                                    <mat-option *ngFor="let lst of formQuestions[in].choices" [value]="lst.ID">
                                        {{lst.txt}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-checkbox *ngIf="q.fvTyp=='C'" (input)='evalForm()'
                                [(ngModel)]="formQuestions[in].value"
                                [disabled]="formDisable"
                            >
                            </mat-checkbox>
                            <mat-form-field *ngIf="q.fvTyp=='F'" appearance="fill">
                                <input matInput
                                    [(ngModel)]="formQuestions[in].value"
                                    disabled
                                >
                            </mat-form-field>
                        </td>
                        <td class="status"> <!-- status opslag -->
                            <mat-icon class='iconbtn' size="small"
                                *ngIf="(q.hideSaveIcon>0 && now<q.hideSaveIcon) || (q.fvDDTmod > q.fvDDT)"
                                [style.color]="q.fvDDTmod > q.fvDDT ? '#ffaa00' : '#009900'"
                            >
                                {{q.fvDDTmod > q.fvDDT ? 'save' : 'checkmark-sharp'}}
                            </mat-icon>
                        </td>
                        <td class='msg'>
                            {{q.msg}}
                        </td>
                    </tr>
                    <tr *ngIf="q.showHelp">
                        <td colspan="5">
                            <mat-card [innerHTML]="q.fvHelp" class='help'></mat-card>
                        </td>
                    </tr>
                </ng-container>
                <tr [hidden]="signatureQ<0">
                    <td *ngIf="signatureQ>=0">
                        <span class="tag">{{formQuestions[signatureQ].fvOms}}</span>
                    </td>
                    <td>
                    </td>
                    <td colspan="3">
                        <div *ngIf="!formDisable">
                            <canvas #signpad (mousedown)="drawStart()" (mouseup)="drawEnd(signatureQ)" (touchstart)="drawStart()" (touchend)="drawEnd(signatureQ)"></canvas>
                            <button mat-button color="primary" (click)="drawClear()">
                                <mat-icon>cancel</mat-icon> Cancel
                            </button><br>
                            <small>Handtekening wordt opgeslagen bij 'VRIJGAVE'</small>
                        </div>
                        <div *ngIf="formDisable && signatureQ>=0">
                            <img src="{{formQuestions[signatureQ].value}}">
                        </div>
                    </td>
                </tr>
            </table>
        </mat-tab>
        <!-- *******************************************************
        TAB FOTO's
        *******************************************************
        -->
        <mat-tab label="Foto's">
            <button mat-raised-button color="primary" *ngIf="formHdr" (click)="doUpload()" style="margin: 8px;">
                <mat-icon>file_upload</mat-icon> Upload
            </button>
            <div *ngIf="!formHdr">Tip: Sla formulier eerst een keer op met knop 'Save', voordat je foto's kunt uploaden.</div>
            <input type="file" #fileUpload id="fileUpload" name="fileUpload"
                multiple="multiple" accept="image/*"
                style="display:none;"
            />
            <div *ngIf="uploading">
                <b>Upload: </b>{{UploadedFiles}} / {{nrUploadFiles}}
                <!-- <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar> -->
            </div>
            <div *ngIf="imgsLoading">
                <mat-spinner></mat-spinner>
            </div>
            <table width="100%">
                <tr *ngFor="let file of imgs; index as i">
                    <td width="250" valign="top" (click)="global.viewerOpen=true; idx=i">
                        <img src="{{global.baseurl + 'doc.php?src=' +imgs[i].path}}" class="squareimg">
                    </td>
                    <td valign="top">
                        <mat-form-field appearance="fill" class="fullwidth">
                            <textarea matInput rows="10" (focusout)='saveTxt(i)' [(ngModel)]="imgs[i].txt"></textarea>
                        </mat-form-field>
                    </td>
                    <td valign="top" width="40px">
                        <button mat-button color="primary" (click)="dlgDelFoto(i, '500ms', '500ms')">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </tr>
            </table>
        </mat-tab>
    </mat-tab-group>
</div>
